import { RouteConfig, RawLocation } from "vue-router";
import { ModuleTree } from "vuex";
import { VuetifyUseOptions, VuetifyTheme } from "vuetify";
import { AxiosRequestConfig } from "axios";
import Vue, { ComponentOptions, AsyncComponent } from "vue";
import { Widget } from "shared/widgets";
import { LocaleMessages } from "vue-i18n";
import { KeyedMessages } from "../i18n";

export enum VuePlugins {
  CompendaIntegration,
}

export interface MenuItem {
  to: RawLocation;
  title: string;
  icon: string;
  hideAuth?: boolean;
  hideNoAuth?: boolean;
  children?: MenuItem[];
  top?: boolean;
  bottom?: boolean;
  asyncShow?: () => Promise<boolean>;
}

export interface ModuleManifest {
  routes?: RouteConfig[];
  storeModules?: ModuleTree<unknown>;
  menuItems?: MenuItem[];
  vuePlugins?: VuePlugins[];
  widgets?: Widget[];
  localisation?: KeyedMessages;
}

export type ModuleManifestFactory = () =>
  | ModuleManifest
  | Promise<ModuleManifest>;

export type ModuleManifestArray = (ModuleManifest | ModuleManifestFactory)[];

export interface BootstrapConfig {
  title: string;
  modules: ModuleManifestArray;
  vuetify: VuetifyUseOptions;
  axios: AxiosRequestConfig;
  customToolbar?: TComponent[];
  continuousAuthCheck: boolean;
  customLocalisation: LocaleMessages;
  branding: boolean;
  loginBackground: boolean | string;
}

export type TComponent = ComponentOptions<Vue> | typeof Vue | AsyncComponent;

export interface ServerSideConfig {
  title?: string;
  branding: boolean;
  login_background: boolean;
  theme: Partial<VuetifyTheme>;
}
